import { ITheme } from "cayo.ui";
import { createGlobalStyle } from "styled-components";
export { default as GridStyle } from "./GridStyle";

const GlobalStyle = createGlobalStyle<ITheme>`
* {
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  padding: 0; 
  margin: 0;
  background-color: ${(props) => props.officeTheme.palette.neutralQuaternaryAlt};
  overflow:hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

label {
  font-weight: 600 !important;
}

.react-grid-layout {
  position: relative;
  
  // transition: height 200ms ease;
}
.react-grid-item {
  transition: all 200ms ease;
  transition-property: left, top;
  
}
.react-grid-item img {
  pointer-events: none;
  user-select: none;  
}

.react-grid-item.cssTransforms {
  transition-property: transform;
}

.react-grid-item.resizing {
  z-index: 1;
  will-change: width, height;
  
}

.react-grid-item.react-draggable-dragging {
  transition: none;
  z-index: 3;
  will-change: transform;
  border: 1px dashed ${(props) => props.cayoTheme.brandColors.disabled};
}

.react-grid-item.dropping {
  visibility: hidden;
}

.react-grid-item.react-grid-placeholder {
  background: ${(props) => props.officeTheme.palette.themePrimary};
  opacity: 0.4;
  transition-duration: 100ms;
  z-index: 2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.react-grid-item > .react-resizable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
}

.react-grid-item > .react-resizable-handle::after {
  content: "";
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 5px;
  height: 5px;
  border-right: 1px solid ${(props) => props.cayoTheme.brandColors.disabled};
  border-bottom: 1px solid ${(props) => props.cayoTheme.brandColors.disabled};
}

.react-resizable-hide > .react-resizable-handle {
  display: none;
}

.react-grid-item > .react-resizable-handle.react-resizable-handle-sw {
  bottom: 0;
  left: 0;
  cursor: sw-resize;
  transform: rotate(90deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-se {
  bottom: 0;
  right: 0;
  cursor: se-resize;
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-nw {
  top: 0;
  left: 0;
  cursor: nw-resize;
  transform: rotate(180deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-ne {
  top: 0;
  right: 0;
  cursor: ne-resize;
  transform: rotate(270deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-w,
.react-grid-item > .react-resizable-handle.react-resizable-handle-e {
  top: 50%;
  margin-top: -10px;
  cursor: ew-resize;
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-w {
  left: 0;
  transform: rotate(135deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-e {
  right: 0;
  transform: rotate(315deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-n,
.react-grid-item > .react-resizable-handle.react-resizable-handle-s {
  left: 50%;
  margin-left: -10px;
  cursor: ns-resize;
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-n {
  top: 0;
  transform: rotate(225deg);
}
.react-grid-item > .react-resizable-handle.react-resizable-handle-s {
  bottom: 0;
  transform: rotate(45deg);
}

input:read-only {
  
  background-color: ${(props) => props.officeTheme.semanticColors.disabledBackground};;
}

 

.container {
  padding: 20px;
}

.header {
  background: #fff;
  border: 1px solid #ddd;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.stat-box {
  flex: 1;
  background: #e8f0fa;
  padding: 20px;
  border-radius: 8px;
}

.stat-box h2 {
  margin: 0;
  font-size: 2em;
  color: #1a73e8;
}

.stat-box p {
  margin-top: 10px;
  color: #333;
}

.content {
  display: flex;
  gap: 20px;
}

.text-block {
  flex: 1;
  background: #fff;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 8px;
}

.text-block h3 {
  margin-top: 0;
}

.text-block button {
  margin-top: 20px;
  padding: 10px 15px;
  border: 1px solid #1a73e8;
  background: none;
  color: #1a73e8;
  cursor: pointer;
  border-radius: 5px;
}

.video-block {
  flex: 1;
}

iframe {
  width: 100%;
  height: 300px;
  border: none;
  border-radius: 8px;
}

.contact-btn {
  padding: 10px 20px;
  background: linear-gradient(to right, #46aef7, #7a6ff0);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

 /* Freemeum Forest Recovery page styles */

  .freemeum-fr-page {
    font-family: 'Montserrat', sans-serif;
    color: #000;
    background: #faf9f8;
    max-height: calc(100vh - 105px);
    overflow: auto;
  }

  .freemeum-fr-page img {
    max-width: 100%;
    display: block;
  }

  .freemeum-fr-page a {
    text-decoration: none;
    color: #00b0f0;
  }

  .freemeum-fr-page a.txt-decor {
    text-decoration: underline;
  }

  .freemeum-fr-page a.style-reset {
    text-decoration: none;
    color: #000;
  }

  .freemeum-fr-page .is-hidden {
    display: none !important;
  }

  .freemeum-fr-page .wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px 20px;
  }

  /* HERO */
  .freemeum-fr-page .hero {
    display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 40px;
    align-items: center;
    padding: 32px 0 10px;
  }

  .freemeum-fr-page .hero .eyebrow {
    display: block;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2em;
  }

  .freemeum-fr-page .hero h1 {
    margin: 0 0 12px;
    font-size: 55px;
    line-height: 1.1em;
  }

  .freemeum-fr-page .hero h1 .lite {
    font-weight: 800;
  }

  .freemeum-fr-page .hero .lead {
    margin: 0 0 32px;
    max-width: 48ch;
    font-size: 20px;
    font-weight: 500;
  }

  .freemeum-fr-page .cta {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .freemeum-fr-page .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 18px;
    border-radius: 999px;
    font-weight: 700;
    transition: 0.2s ease;
    border: 1px solid transparent;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    font-size: 14px;
  }

  .freemeum-fr-page .btn.orange {
    background: #ff801e;
    color: #fff;
  }

  .freemeum-fr-page .btn.orange:hover {
    transform: translateY(-1px);
    filter: saturate(1.05);
  }

  .freemeum-fr-page .btn.blue {
    background: #0ea5e9;
    color: #fff;
  }

  .freemeum-fr-page .btn.blue:hover {
    background: #0284c7;
    transform: translateY(-1px);
  }

  .freemeum-fr-page .hero-card video {
    width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    display: block;
  }

  .freemeum-fr-page .hero-card .e-hosted-video {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    position: relative;
  }

  .freemeum-fr-page .hero-card .elementor-custom-embed-image-overlay {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .freemeum-fr-page .hero-card .elementor-custom-embed-play {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
    font-size: 28px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    transition: transform 0.2s ease;
  }

  .freemeum-fr-page .hero-card .elementor-custom-embed-play:hover {
    transform: scale(1.08);
  }

  .freemeum-fr-page .hero-card .elementor-custom-embed-play i::before {
    content: "▶";
    font-style: normal;
    font-size: 26px;
    color: #333;
    margin-left: 4px;
  }

  /* FASTEST SECTION */
  .freemeum-fr-page .headline {
    margin: 45px 0 20px;
    font-weight: 400;
    line-height: 43px;
    font-size: 36px;
    letter-spacing: -0.01em;
  }

  .freemeum-fr-page .sub {
    margin: 0 0 12px;
    font-size: 20px;
  }

  .freemeum-fr-page .pill-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;
    margin: 22px 0 34px;
  }

  .freemeum-fr-page .pill {
    background: #f5fafc;
    border: 1px solid #e9eef3;
    border-radius: 14px;
    padding: 18px 18px 16px;
  }

  .freemeum-fr-page .pill h3 {
    margin: 0 0 6px;
    font-size: 27px;
    color: #1f4e79;
  }

  .freemeum-fr-page .pill p {
    margin: 0;
    color: #1f4e79;
    font-size: 18px;
    font-weight: 500;
  }

  /* AWARDS */
  .freemeum-fr-page .awards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    background: linear-gradient(180deg, #f7fcff 0%, #ffffff 60%);
    padding: 22px;
    border-radius: 16px;
    border: 1px solid #e9eef3;
  }

  .freemeum-fr-page .award {
    background: #fff;
    border: 1px solid #e9eef3;
    border-radius: 12px;
    padding: 10px 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    display: grid;
    grid-template-columns: 171px 1fr;
    gap: 10px;
    align-items: center;
  }

  .freemeum-fr-page .award .thumb {
    width: 150px;
    height: 80px;
    border-radius: 10px;
    overflow: hidden;
    background: #eef4fa;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #96a3b4;
  }

  .freemeum-fr-page .award h5 {
    margin: 0 0 3px;
    font-size: 14px;
  }

  .freemeum-fr-page .award p {
    margin: 0;
    font-size: 12px;
  }

  /* FEATURES */
  .freemeum-fr-page .features {
    margin: 44px 0;
  }

  .freemeum-fr-page .features h3 {
    font-size: 36px;
    font-weight: 400;
    margin: 0 0 18px;
    color: #2d3a47;
  }

  .freemeum-fr-page .fb {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 26px;
    background: #f9fbfd;
    border: 1px solid #e9eef3;
    border-radius: 16px;
    padding: 16px;
  }

  .freemeum-fr-page .f-nav {
    border-right: 1px solid #e9eef3;
    padding: 8px 6px 8px 8px;
  }

  .freemeum-fr-page .f-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .freemeum-fr-page .f-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 10px;
    cursor: pointer;
    color: #00b0f0;
    font-weight: 600;
    border: 1px solid transparent;
  }

  .freemeum-fr-page .f-item:hover {
    background: #eef7ff;
  }

  .freemeum-fr-page .f-item.active {
    color: #1f4e79;
  }

  .freemeum-fr-page .f-body {
    padding: 8px 10px;
  }

  .freemeum-fr-page .pane {
    display: none;
  }

  .freemeum-fr-page .pane.active {
    display: block;
  }

  .freemeum-fr-page .pane h4 {
    margin: 0 0 8px;
    font-size: 40px;
    font-weight: 600;
    color: #00b0f0;
  }

  .freemeum-fr-page .pane p {
    margin: 0 0 10px;
    font-size: 15px;
  }

  .freemeum-fr-page .pane ul {
    margin: 10px 0 0 18px;
    font-size: 15px;
  }

  .freemeum-fr-page .download {
    margin-top: 12px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 12px;
    border: 1px solid #e9eef3;
    background: #fff;
    font-weight: 600;
  }

  .freemeum-fr-page .download:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  }

  .freemeum-fr-page .icon-file {
    width: 16px;
    height: 16px;
    border-radius: 3px;
    background: #0ea5e9;
  }

  /* RESPONSIVE */
  @media (max-width: 1024px) {
    .freemeum-fr-page .hero {
      grid-template-columns: 1fr;
      gap: 22px;
    }
  }

  @media (max-width: 840px) {
    .freemeum-fr-page .pill-grid {
      grid-template-columns: 1fr;
    }

    .freemeum-fr-page .awards {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .freemeum-fr-page .fb {
      grid-template-columns: 1fr;
    }

    .freemeum-fr-page .f-nav {
      border-right: none;
      border-bottom: 1px solid #e9eef3;
      padding-bottom: 12px;
      margin-bottom: 6px;
    }

    .freemeum-fr-page .f-list {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 8px;
    }

    .freemeum-fr-page .f-item {
      padding: 8px 10px;
    }
  }

 /* Freemeum Forest Recovery page styles  END*/
`;

export default GlobalStyle;
